import { render, staticRenderFns } from "./Talent-pool.vue?vue&type=template&id=631047d9&scoped=true&"
import script from "./Talent-pool.vue?vue&type=script&lang=js&"
export * from "./Talent-pool.vue?vue&type=script&lang=js&"
import style0 from "./Talent-pool.vue?vue&type=style&index=0&id=631047d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631047d9",
  null
  
)

export default component.exports